import { Component } from '@angular/core';
import { Globals } from '../../../../../globals';
import { NavController } from 'ionic-angular';

@Component({
    selector: 'page-home-version',
    templateUrl: 'home-version.html'
})


export class HomeVersionPage {

    constructor(public globals: Globals,
        public navCtrl: NavController) {
    }

}



// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-cards/home-version/home-version.ts